import firebase from 'firebase/app'
import 'firebase/firestore'
import { firebaseConfig } from './firebase-config'

firebase.initializeApp(firebaseConfig)
const db = firebase.firestore()

const usersCollection = db.collection('users')
const caring_box = db.collection('caring-box')

export {
    db,
    usersCollection,
    caring_box
}